import React, { useEffect, useRef } from 'react';
import PropTypes         from 'prop-types';

import ActorProfileHeatMap          from '../ActorProfileFeed/ActorProfileHeatMap';
import ActorProfileRecommendations  from '../ActorProfileRecommendations';
import Awards                       from '../ActorProfileAbout/Awards';
import InfoOverview                 from './InfoOverview';
import LatestContentRecommendations from './LatestContentRecommendations';

const ActorProfileOverview = (props) => {

    const {actorData, isGuestLoggedIn, navigateTo, routes} = props;

    return (
        <>
            <InfoOverview
                actorData    = {actorData}
                routes       = {routes}
            />

            {actorData.isHeatmapActive && <section className='container-block actor-heatmap-block -margin-bottom-lg row'>
                <div className='context-box--actor-profile'>
                        <ActorProfileHeatMap
                            actorId         = {actorData.id}
                            actorIsOnline   = {actorData.isOnline}
                            actorLastOnline = {actorData.lastOnline}
                            isLoggedIn      = {isGuestLoggedIn}
                            isMobile        = {false}
                            isOverview      = {true}
                        />
                </div>
            </section>}

            {actorData.awards && <Awards
                awards = {actorData.awards}
            />}

            {!actorData.isVideoActor && <LatestContentRecommendations
                navigateTo             = {navigateTo}
                actorName              = {actorData.name}
                actorId                = {actorData.id}
                count                  = {actorData.videosCount}
                isVideoContent         = {true}
                routes                 = {routes}
            />}

            <ActorProfileRecommendations
                actorId = {actorData.id}
            />
        </>
    )
}

ActorProfileOverview.propTypes = {
    actorData:       PropTypes.object.isRequired,
    isGuestLoggedIn: PropTypes.bool.isRequired,
    navigateTo:      PropTypes.func.isRequired,
    routes:          PropTypes.object.isRequired
}

export default ActorProfileOverview
